import ReferralSourceFormDataCard from 'routes/ReferralSourceAnalytics/ReferralSourceFormDataCard/ReferralSourceFormDataCard';

export default ReferralSourceFormDataCard;
